/**
 * Akva (Emilie 8/10): undermenuen starter under sit hovedpunkt.
 *
 * Fabrics megamenu i tekststil lægger undermenuens links ved sidemargenen.
 * Her flyttes listen, så første link flugter med hovedpunktets tekst
 * ("Stabilization" under "Construction"). Products står længst til venstre
 * og flytter sig derfor kun en pixel.
 *
 * - Afstanden sættes som --akva-undermenu-x på .menu-list__submenu, og CSS'en
 *   i blocks/_header-menu.liquid flytter listen med position: relative. Det
 *   ændrer ikke højden, som header-menu.js måler.
 * - Listen holder sig inden for sidemargenen i begge sider. Bliver der ikke
 *   plads til højre, rykker den kun så langt, der er plads til.
 * - Kun lister med data-akva-flugt (tekststil, snippets/mega-menu-list.liquid)
 *   og kun punkter i selve menulinjen, ikke dem under "Mere".
 * - Måles, når Fabric åbner undermenuen (data-active). En MutationObserver
 *   kører før næste optegning, så der er intet hop. Er den åben, når
 *   vinduet ændrer størrelse, eller skriften bliver hentet, måles igen.
 */
const VAR = '--akva-undermenu-x';

/** @param {HTMLElement} submenu */
function placer(submenu) {
  const item = submenu.closest('.menu-list__list-item');
  const list = submenu.querySelector('.mega-menu__list[data-akva-flugt]');
  if (!item || !list) return;

  if (item.getAttribute('slot') === 'overflow') {
    submenu.style.removeProperty(VAR);
    return;
  }

  const title = item.querySelector('.menu-list__link-title');
  const grid = submenu.querySelector('.mega-menu__grid');
  if (!title || !grid) return;

  const t = title.getBoundingClientRect();
  if (!t.width) return;
  // Teksten starter efter titlens egen luft (padding-inline i blokken).
  const tekst = t.left + (parseFloat(getComputedStyle(title).paddingLeft) || 0);

  // Positionerne måles uden den nuværende forskydning.
  const nu = parseFloat(submenu.style.getPropertyValue(VAR)) || 0;
  let foerste = null;
  let venstre = Infinity;
  let hoejre = -Infinity;
  for (const link of list.querySelectorAll('.mega-menu__link')) {
    const r = link.getBoundingClientRect();
    if (!r.width) continue;
    foerste ??= r.left - nu;
    venstre = Math.min(venstre, r.left - nu);
    hoejre = Math.max(hoejre, r.right - nu);
  }
  if (foerste === null) return;

  const g = grid.getBoundingClientRect();
  let x = tekst - foerste;
  x = Math.min(x, g.right - hoejre);
  x = Math.max(x, g.left - venstre);
  submenu.style.setProperty(VAR, `${Math.round(x)}px`);
}

function placerAabne() {
  document.querySelectorAll('header-menu .menu-list__submenu[data-active]').forEach((s) => {
    if (s instanceof HTMLElement) placer(s);
  });
}

new MutationObserver((records) => {
  for (const { target } of records) {
    if (target instanceof HTMLElement && target.matches('.menu-list__submenu[data-active]')) placer(target);
  }
}).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['data-active'] });

window.addEventListener('resize', placerAabne);
document.fonts?.addEventListener('loadingdone', placerAabne);
